import classNames from 'classnames';
import DiagnosticResourceId from 'components/dev-tools/DiagnosticResourceId';
import Label from 'components/Label';
import { clamp } from 'lodash-es';
import React, { useCallback, useState } from 'react';
import FontAwesome from 'react-fontawesome';
import { prefixHexColor } from 'utils/colors';
import type { GanttProjectRow } from '../gantt-types';

import styles from './LeftHeader.module.scss';

interface Props {
  row: GanttProjectRow;
  isLastRow: boolean;
  style: React.CSSProperties;
  rowHeight: number;
  scrollTop: number;
}

const VERTICAL_PADDING = 8;
const LeftProjectCell: React.FC<Props> = ({ row, style, rowHeight, scrollTop }: Props) => {
  // Make project sticky during scroll
  const [cellHeight, setCellHeight] = useState<number>(0);
  const cellRowRef = useCallback((element: HTMLDivElement | null) => {
    setCellHeight(element?.offsetHeight ?? 0);
  }, []);
  const top = clamp(
    scrollTop - Number(style.top!),
    0,
    rowHeight - cellHeight - VERTICAL_PADDING * 2
  );

  return (
    <div className={styles.leftHeaderCell}>
      <div className={styles.project} ref={cellRowRef} style={{ top }}>
        <div className={styles.color} style={{ background: prefixHexColor(row.displayColor) }} />
        <div className={styles.text} style={{ width: '80%' }}>
          <div className={classNames(styles.name, 'fs-mask')}>
            <DiagnosticResourceId resource={row.type} id={row.projectId} />
            {row.name}
            {row.type === 'project' && row.projectArchived && (
              <Label className={styles.archived}>
                <FontAwesome name="archive" />
              </Label>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default LeftProjectCell;
